import React from 'react'
import PropTypes from "prop-types";

const SEO = ({ title }) => {
    return (
        <>
            <meta charSet="utf-8" />
            <title>Sousa Électricien | {title}</title>
            <meta name="robots" content="noindex, follow" />
            <meta name="description" content="électricien professionnel installation électrique dépannage électrique mise aux normes électriques tableau électrique câblage électrique rénovation électrique électricien Nyon courant fort / courant faible domotique borne de recharge voiture électrique éclairage intérieur / extérieur interphone / visiophone installation prise et interrupteur maintenance informatique dépannage informatique installation réseau informatique cybersécurité câblage informatique assistance informatique installation serveur configuration PC et imprimante infogérance informatique pour professionnels solutions IT sauvegarde de données sécurité réseau technicien informatique nyon  installation réseau domestique courant faible et réseau informatique domotique et maison connectée système de sécurité (alarme, vidéosurveillance) câblage structuré baies de brassage intégration électrique & informatique fibre optique smart home gestion d’accès devis gratuit électricité technicien certifié intervention rapide dépannage urgent services pour particuliers et professionnels contrat de maintenance informatique" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;